import React, { useEffect } from 'react';
import { Form, Input } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';

import EditDependencies from './EditDependencies';
import messages from './messages';

const EditBlock = ({
  intl: { formatMessage: $t },
  block, dependencies, dependencyOperator, surveyQuestions = [],
  form, onSubmit,
}) => {
  const initialValues = {
    title: block.title,
    dependencies,
    dependencyOperator,
  };

  useEffect(() => {
    if (block) {
      form.resetFields();
    }
  }, [block]);

  return (
    <Form layout="vertical" form={form} onFinish={onSubmit} initialValues={initialValues}>
      <Form.Item
        name="title"
        label={<FormattedMessage {...messages.blockTitle} />}
        rules={[{ required: true, message: $t(messages.blockTitleRequired) }]}
      >
        <Input placeholder={$t(messages.blockTitlePlaceholder)} />
      </Form.Item>
      <EditDependencies questions={surveyQuestions} />
    </Form>
  );
};

export default injectIntl(EditBlock);
